import { useCallback, useMemo } from 'react';

import { ListTasks } from '../api/queries/list-tasks';
import { TaskCardType } from '../entities/task-card-type';
import { ViewMode } from '../types/view-mode';

export function useFilterConfig(filters: ListTasks.Filters) {
  const isProjectManagementMode = useMemo(
    () => filters.viewMode === ViewMode.PROJECT_MANAGEMENT,
    [filters.viewMode],
  );

  const shouldHideCardType = useCallback(
    function (
      cardType: TaskCardType | undefined,
      input: ListTasks.Filters = filters,
    ): boolean {
      if (isProjectManagementMode) {
        return cardType !== TaskCardType.STANDARD;
      }

      if (!input.cardType) {
        return false;
      }

      return input.cardType !== cardType;
    },
    [filters, isProjectManagementMode],
  );

  return useMemo(
    () => ({
      isProjectManagementMode,
      shouldHideCardType,
    }),
    [isProjectManagementMode, shouldHideCardType],
  );
}
